var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemSphereElement_1;
import { CustomElement, P, Watch, PropertyConverters } from '@pacem/pacem-core';
import { computeSharpVertexNormals } from '../types';
import { MeshGeometry } from '../geometry';
import { Pacem3DPrimitiveElement } from './primitive';
import { TAG_MIDDLE_NAME, DEG2RAD } from '../constants';
//namespace Pacem.Components.Drawing3D {
let PacemSphereElement = PacemSphereElement_1 = class PacemSphereElement extends Pacem3DPrimitiveElement {
    static createMeshGeometry(radius = 1, segs = 8) {
        //
        const nodes = [];
        const uv = [];
        const indices = [];
        //
        const r = radius, tessellation = segs;
        const theta = DEG2RAD * (360.0 / tessellation);
        const segments = tessellation % 2 == 0 ? tessellation / 2 : (tessellation - 1) / 2;
        // top vertex
        nodes.push({ x: .0, y: r, z: .0 });
        for (let j = 1; j < segments; j++) {
            // loop "latitude"
            const angle1 = theta * j;
            const cos_angle1 = Math.cos(angle1);
            const sin_angle1 = Math.sin(angle1);
            const v = 1.0 - 1.0 * j / segments;
            for (let i = 0; i < tessellation; i++) {
                // loop "longitude"
                const angle2 = theta * i - Math.PI / 2.0;
                const cos_angle2 = Math.cos(angle2);
                const sin_angle2 = Math.sin(angle2);
                const x = r * sin_angle1 * cos_angle2;
                const y = r * cos_angle1;
                const z = r * sin_angle1 * sin_angle2;
                nodes.push({ x, y, z });
                // coordinates & texture
                const i_prev = i == 0 ? tessellation - 1 : i - 1;
                const u = i == 0 ? .0 : 1.0 - 1.0 * i / tessellation;
                const u_prev = 1.0 - 1.0 * i_prev / tessellation;
                // triangles
                if (j == 1) {
                    indices.push(1 + i);
                    indices.push(1 + i_prev);
                    indices.push(0);
                    //
                    uv.push({ x: u, y: v });
                    uv.push({ x: u_prev, y: v });
                    uv.push({ x: .5, y: 1.0 });
                }
                else {
                    indices.push((j - 1) * tessellation + i + 1);
                    indices.push((j - 1) * tessellation + i_prev + 1);
                    indices.push((j - 2) * tessellation + i_prev + 1);
                    indices.push((j - 1) * tessellation + i + 1);
                    indices.push((j - 2) * tessellation + i_prev + 1);
                    indices.push((j - 2) * tessellation + i + 1);
                    //
                    const v_prev = 1.0 - (j - 1.0) / segments;
                    //var faceUV = [];
                    uv.push({ x: u, y: v });
                    uv.push({ x: u_prev, y: v });
                    uv.push({ x: u_prev, y: v_prev });
                    uv.push({ x: u, y: v });
                    uv.push({ x: u_prev, y: v_prev });
                    uv.push({ x: u, y: v_prev });
                }
            }
        }
        // bottom vertex
        nodes.push({ x: .0, y: -r, z: .0 });
        const last = nodes.length - 1;
        for (let i = 0; i < tessellation; i++) {
            const j = segments - 2;
            const i_prev = i == 0 ? tessellation - 1 : i - 1;
            const u = i == 0 ? .0 : 1.0 - 1.0 * i / tessellation;
            const u_prev = 1.0 - 1.0 * i_prev / tessellation;
            const v = 1.0 - (j + 1.0) / segments;
            // triangles
            indices.push(last);
            indices.push(j * tessellation + 1 + i_prev);
            indices.push(j * tessellation + 1 + i);
            uv.push({ x: .5, y: 0 });
            uv.push({ x: u_prev, y: v });
            uv.push({ x: u, y: v });
        }
        const geom = new MeshGeometry(nodes, indices, uv);
        geom.key = `sphere_${radius}_s${segs}`;
        computeSharpVertexNormals(geom);
        return geom;
    }
    createDefaultGeometry() {
        return PacemSphereElement_1.createMeshGeometry();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'radius':
            case 'segments':
                this.geometry = PacemSphereElement_1.createMeshGeometry(this.radius, this.segments);
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSphereElement.prototype, "radius", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSphereElement.prototype, "segments", void 0);
PacemSphereElement = PacemSphereElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-primitive-sphere' })
], PacemSphereElement);
export { PacemSphereElement };
